export default {
  有效交易量达标即可获得:`รางวัลจะได้รับเมื่อมีปริมาณการซื้อขายที่มีผลตามเกณฑ์ที่กำหนด โปรดดูรายละเอียดเพิ่มเติมใน<a href="#pay-session5">ข้อควรระวัง</a>`,

  交易领薪计划: "โปรแกรมมาสเตอร์",
  为了鼓励交易者提升交易水平:`ปลดล็อกฝีมือเทรด สู่ค่าธรรมเนียม <span class="red">18<span class="sRed">%</span></span> ต่อปี`,
  加入交易社区:
    "",
  即刻发起交易信号: "ปล่อยสัญญาณเทรด",
  无限奖励月月拿: "รางวัลเงินเดือนไม่จำกัด",
  优享11个专属大礼: "ของขวัญพิเศษ 11 รายการ",
  即刻加入: "เข้าร่วมตอนนี้",
  交易员等级奖励机制: `รางวัลตามระดับมาสเตอร์`,
  EBC基于跟随人数和资金提供五档奖励:
    "EBC มีระบบรางวัล 5 ระดับ พิจารณาจากจำนวนผู้ติดตามและจำนวนเงินทุน โดยไม่จำกัดจำนวนครั้งในการเทรด และใช้เกณฑ์วัดผลจากการเป็นที่ยอมรับในตลาดเท่านั้น",
  "/月": "/เดือน",
  精英交易员: "ระดับเริ่มต้น",
  // 管理资金量: "สินทรัพย์ภายใต้การจัดการ",
  // 跟随账户数: "จำนวนผู้ติดตาม",
  管理资金量: "AUM",
  跟随账户数: "Followers",
  大师交易员: "ระดับกลาง",
  冠军交易员: "ระดับสูง",
  明星交易员: "ระดับมืออาชีพ",
  资金管理费: "ค่าธรรมเนียมจัดการ 1%",
  传奇交易员: "ระดับตำนาน",
  多层次的增值服务: "บริการเสริมหลากหลายระดับ",
  EBC提供多达11项增值服务:
    "EBC สนับสนุนบริการเสริมถึง 11 รายการ เพื่อเพิ่มการรับรู้ และสร้างตัวตนให้กับเทรดเดอร์",
  "精英/大师交易员": "ระดับเริ่มต้น/ระดับกลาง",

  "7×24小时优先客服": "ฝ่ายบริการลูกค้า 24/7",
  金融投资经典书籍礼遇: "รับฟรีหนังสือลงทุน",
  专属VPS赞助: "ให้การสนับสนุน VPS",
  订单流软件1年使用权: "ใช้งานเครื่องมือ Order Flow ฟรี 1 ปี",
  EBC定制大礼包: "ของขวัญสุดพิเศษจาก EBC",
  信号优先置顶展示: "ปักหมุดสัญญาณเทรด",
  受邀参观海外办公室: "เยี่ยมชมสํานักงาน EBC สาขาต่างประเทศ",
  巴萨球星联名礼包: "ของขวัญจากสโมสรบาร์เซโลนา",
  巴萨赛场传奇之旅: "ทัวร์สนามแข่งสโมสรบาร์เซโลนา",
  品牌战略合作: "ความร่วมมือกลยุทธ์แบรนด์",
  全球金融资源管家服务: "บริการทรัพยากรการเงินระดับโลก",
  五维指标评价系统: "วิเคราะห์ตัวชี้วัด 5 มิติ",
  为交易员信号提供公开透明的评估:
    "เปิดเผยสัญญาณเทรดอย่างโปร่งใส แสดงสไตล์การเทรด เพิ่มการรับรู้ และดึงดูดผู้ติดตามมากขึ้น",
  收益率: "อัตราผลกำไร",
  历史收益率: "อัตราผลกำไรในอดีต ยิ่งสูงยิ่งดี",
  最大回撤: "อัตราขาดทุนสูงสุด",
  衡量风控能力: "ตัวชี้วัดความสามารถควบคุมความเสี่ยง ยิ่งต่ำยิ่งดี",
  获利系数: "อัตราตัวคูณกำไร",
  利润因子: "ตัวขี้วัดกลยุทธ์ทำกำไร ยิ่งสูงการทำกำไรยิ่งแกร่ง",
  夏普比率: "อัตราผลตอบแทนต่อความเสี่ยง",
  每份风险的收益: "ตัวชี้วัดผลตอบแทนต่อความเสี่ยง ยิ่งสูงยิ่งคุ้มค่า",
  标准差: "อัตราความผันผวนของผลตอบแทน",
  收益波动率: "ตัวชี้วัดความผันผวน ยิ่งต่ำความผันผวนยิ่งน้อย",
  以上数据仅供参考: "*ข้อมูลข้างต้นใช้สำหรับการอ้างอิงเท่านั้น",
  活动须知: "ข้อควรระวัง",
   list: [
    {
      label: "1. คำจำกัดความของผู้ติดตาม",
      value: [
        {label:'เงินทุนติดตาม: ยอดคงเหลือของบัญชี ÷ จำนวนผู้ให้สัญญาณที่ติดตาม',value:[]},
        {label:'ข้อจำกัดการติดตาม: แต่ละบัญชีสามารถติดตามผู้ให้สัญญาณได้สูงสุด 10 คนในเวลาเดียวกัน',value:[]},
        {label:'บัญชีผู้ติดตามที่มีผล: บัญชีจะถือว่ามีผลหากมีเงินทุนติดตาม ≥ 500 USD หากบัญชีมีเงินทุนติดตามไม่ถึง 500 USD จะไม่นับเป็นบัญชีที่มีผล และจะไม่ถูกรวมอยู่ในยอดเงินทุนติดตามทั้งหมด​',value:[]},
        {label:'ผู้ติดตามที่มีผล: หากมีหลายบัญชีเทรดที่เข้าเงื่อนไขภายใต้ผู้ใช้ EBC รายเดียวกันและติดตามผู้ให้สัญญาณคนเดียวกัน ระบบจะนับรวมเป็นผู้ติดตามที่มีผลเพียง 1 คนเท่านั้น',value:[]},
        {label:'สินทรัพย์ที่บริหาร: = จำนวนเงินติดตามทั้งหมด + ยอดคงเหลือของบัญชีของเทรดเดอร์ (ผู้ให้สัญญาณ)',value:[]},
        // {label:'การยกเว้นข้อมูล: บัญชีเทรดของผู้ตามที่ติดตามสัญญาณของตนเอง จะไม่ถูกนับรวมในจำนวนผู้ติดตามที่มีผล และไม่รวมในยอดเงินทุนติดตาม',value:[]}
      ],
    },
    {
      label: "2. กติกาการเปิดใช้งานระดับและเงื่อนไขการรับรางวัล",
      value: [
        {label:'การเปิดใช้งานระดับ:',value:[{innerLabel:'ระบบจะทำการประเมินโดยอัตโนมัติในทุกชั่วโมง หากทั้งสินทรัพย์ที่บริหาร และจำนวนผู้ติดตามที่ผ่านเกณฑ์ตรงตามข้อกำหนดของระดับใดระดับหนึ่ง ระบบจะถือว่าระดับนั้นถูกเปิดใช้งาน',innerValue:[]}]},
        {label:'เงื่อนไขการรับรางวัล (ต้องครบทุกเงื่อนไข):',value:[{innerLabel:'เทรดเดอร์ต้องรักษาระดับที่กำหนดไว้ให้ครบทุกวันของเดือนตามปฏิทิน',innerValue:[]},{innerLabel:'ปริมาณการซื้อขายที่มีผล (ล็อต)  ≥  ยอดคงเหลือเฉลี่ยรายวันของบัญชีเทรดเดอร์ (ผู้ให้สัญญาณ) × 0.2%:',innerValue:['ปริมาณการซื้อขายที่มีผล = ปริมาณการปิดสถานะทั้งหมดในเดือนนั้น + ปริมาณสุทธิของสถานะที่เปิดอยู่ (ปริมาณสุทธิของสถานะที่เปิดอยู่ = ปริมาณสถานะที่เปิดทั้งหมด − ปริมาณสถานะที่ป้องกันความเสี่ยงในสินค้าประเภทเดียวกัน)','ยอดคงเหลือเฉลี่ยรายวัน = ผลรวมของยอดคงเหลือรายวันของบัญชีเทรดเดอร์  (ผู้ให้สัญญาณ) ÷ จำนวนวันตามปฏิทินในเดือนนั้น','หุ้นสหรัฐและ ETF จะไม่ถูกนับรวมในการคำนวณปริมาณการซื้อขายที่มีผล']}]},
        {label:'การคำนวณและการจ่ายโบนัส:',value:['สินทรัพย์ที่บริหารรายวัน = ผลรวมของสินทรัพย์ที่บริหารรายวัน ÷ จำนวนวันตามปฏิทินในเดือนนั้น','โบนัสรายเดือน = (สินทรัพย์ที่บริหารเฉลี่ยรายวัน × อัตราค่าธรรมเนียมการบริหารเงิน) ÷ 12','รางวัลทั้งหมดจะถูกโอนเข้าสู่บัญชีซื้อขาย และสามารถถอนออกได้อย่างอิสระ','กิจกรรมนี้จะมีผลก็ต่อเมื่อ ลูกค้าทำถูกต้องตามเงื่อนไขเท่านั้น และ EBC มีสิทธิ์ในการตีความหรือตัดสิน ทุกกรณีที่เกี่ยวข้องกับกิจกรรมนี้']}
      ],
    }
  ],
  年化资金管理费: "ค่าธรรมเนียมการจัดการ (รายปี)",
};
